var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tb cor-primaria-border cor-primaria-text"},[_c('div',{staticClass:"tb-fill"},[_c('div',{staticClass:"text-bold"},[_vm._v(_vm._s(_vm.titulo))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.descricao))])]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46bc707c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Widgets/TituloDestacado.vue
// module id = null
// module chunks = 